<template>
  <v-card class="rounded-card mb-4" flat outlined>
    <v-card-text>
      <div class="overline grey--text text--darken-1 mb-1">
        {{ $t('views.appraisals.show.questionLabel', { number: index + 1 }) }}
      </div>
      <div class="text-h6 font-weight-medium mb-3">{{ question.body }}</div>

      <template v-for="(reference, refIndex) in references">
        <div :key="`${reference.label}-label`"
          :class="['caption', 'grey--text', 'text--darken-1', 'mb-1', { 'mt-4': refIndex > 0 }]">
          {{ reference.label }}
        </div>
        <app-field :key="`${reference.label}-field`" type="text" :label="answerLabel" :value="reference.value"
          disabled hide-details />
      </template>

      <div class="caption grey--text text--darken-1 mt-4 mb-1">{{ editableLabel }}</div>

      <app-field v-if="question.questionType === questionTypes.FREE_TEXT" type="textarea" :label="answerLabel"
        :value="value" @input="$emit('input', $event)" :rules="requiredRule" hide-details />

      <v-radio-group v-else-if="question.questionType === questionTypes.MCQ" :value="value"
        @change="$emit('input', $event)" :rules="radioRule" class="mt-0" hide-details>
        <v-radio v-for="option in question.options" :key="option.id" :value="option.id">
          <template v-slot:label>
            <span>
              {{ option.body }}
              <span v-if="question.isScored" class="grey--text">({{ option.score }} pts)</span>
            </span>
          </template>
        </v-radio>
      </v-radio-group>

      <div v-if="error" class="error--text caption mt-1">{{ error }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'QuestionAnswerCard',
  props: {
    question: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    references: {
      type: Array,
      default: () => []
    },
    editableLabel: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    answerLabel: {
      type: String,
      required: true
    },
    questionTypes: {
      type: Object,
      required: true
    },
    requiredRule: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      radioRule: [(value) => !!value]
    };
  }
};
</script>
